import React from "react";
import PermitApprovers from "../PermitApprovers";
import { parkingStickerRequestSupportingDocuments, WorkPermitApprover } from "../../../constants/common";
import ParkingAccessDetails from "./ParkingAccessDetails";
import EmployeeInformation from "./EmployeeInformation";
import VehicleInformation from "./VehicleInformation";
import SupportingDocuments from "../SupportingDocuments";
import Wrapper from "../Wrapper";

interface ParkingStickerRequestPermitPDFProps {
  permitDetails: {
    s_Name: string;
    s_Department: string;
    s_JobTitle: string;
    s_MobileNo: string;
    s_OfficePhone: string;
    s_EmployeeNumber: string;

    vehicles: {
      s_PlateSource_En: string;
      s_PlateLetter1_En: string;
      s_PlateLetter2_En: string;
      s_PlateLetter3_En: string;
      s_PlateNo: string;
      s_ModelNumber: string;
      s_Color: string;
      s_StickerNumber: string;
      s_CopyNumber: string;
      haveVehicleRegistrationFile: boolean;
    }[];

    vehicleAccess: {
      s_VehicleAccess_En: string;
    }[];
    buildings: {
      s_LocationName_En: string;
      s_LocationName_Ar: string;
      items: {
        s_BuildingName_En: string;
        s_BuildingName_Ar: string;
      }[];
    }[];

    haveHostEmployeeCard: boolean;
    haveHostNationalID: boolean;

    approvers: WorkPermitApprover[];
  };
}

const ParkingStickerRequestPermitPDF: React.FC<ParkingStickerRequestPermitPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title="Parking Sticker Request">
      <ParkingAccessDetails permitDetails={permitDetails} />
      <EmployeeInformation permitDetails={permitDetails} />
      <VehicleInformation vehicles={permitDetails?.vehicles} />
      <SupportingDocuments sectionNumber={4} permitDetails={permitDetails} documents={parkingStickerRequestSupportingDocuments} />
      <PermitApprovers sectionNumber={5} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default ParkingStickerRequestPermitPDF;
